import { useEffect, useState } from 'react';
import { useRoutes } from 'react-router-dom';

// routes
import ThemeRoutesFullLayout from './Router';
import AuthenticationRoutes from './AuthenticationRoutes';
import { useCookies } from 'react-cookie';
import { canRestoreSession, ensureAccessToken } from '../api/authSession';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const [cookies] = useCookies(['token']);
  const token = cookies.token;
  // Access-куки нет (истекла, Safari стёр через 7 дней), но refresh-сессия может быть жива:
  // сперва тихо восстанавливаем, иначе пользователя выкинуло бы на публичные роуты.
  const [restoring, setRestoring] = useState(canRestoreSession);

  useEffect(() => {
    if (!restoring) return undefined;
    let active = true;
    ensureAccessToken().finally(() => {
      if (active) setRestoring(false);
    });
    return () => {
      active = false;
    };
  }, [restoring]);

  const routes = useRoutes([token ? ThemeRoutesFullLayout : AuthenticationRoutes], '');
  return restoring ? null : routes;
}
